export default "__VITE_ASSET__CEhk3E$O__"